import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import { Checkbox, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material';
import { IDroit } from '../utilisateurAppGestionInterneSlice';




const Demo = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
}));

export interface ICustomListeProps {
    localDroits: any
    rightsChecked: any
    setRightsChecked: any
}

export default function CustomListe(props: ICustomListeProps) {
    const { localDroits, rightsChecked, setRightsChecked } = props




    // const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     let newSelected: readonly number[] = [];
    //     if (event.target.checked) {
    //         newSelected = localDroits.map((n: IDroit) => n.idDroit);
    //         setRightsChecked(newSelected);
    //         return;
    //     }
    //     setRightsChecked([]);
    // };


    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected: readonly string[] = localDroits
                .map((n: IDroit) => n.idDroit)
                .filter((idDroit: string) => !rightsChecked.includes(idDroit));

            setRightsChecked([...rightsChecked, ...newSelected]);
        } else {
            setRightsChecked([]);
        }
    };



    const handleClick = (id: any) => {
        const rightsCheckedIndex = rightsChecked.indexOf(id);
        let newSelected: readonly number[] = [];
        if (rightsCheckedIndex === -1) {
            newSelected = newSelected.concat(rightsChecked, id);
        } else if (rightsCheckedIndex === 0) {
            newSelected = newSelected.concat(rightsChecked.slice(1));
        } else if (rightsCheckedIndex === rightsChecked.length - 1) {
            newSelected = newSelected.concat(rightsChecked.slice(0, -1));
        } else if (rightsCheckedIndex > 0) {
            newSelected = newSelected.concat(
                rightsChecked.slice(0, rightsCheckedIndex),
                rightsChecked.slice(rightsCheckedIndex + 1),
            );
        }
        setRightsChecked(newSelected);
    };


    return (
        <Box sx={{ flexGrow: 1, width: "100%", background: 'white', height: "52vh", overflow: "auto" }}>
            <ListItem>
                <ListItemButton onClick={(e: any) => handleSelectAllClick(e)}>
                    <Checkbox
                        checked={rightsChecked.length > 0 && rightsChecked.length === localDroits.length}
                        tabIndex={-1}
                    />
                    <ListItemText
                        primary={`Cocher tout`}
                    />
                </ListItemButton>
            </ListItem>
            <Divider />
            <List dense>
                {localDroits.map((item: any, index: number) => (
                    <ListItem key={index}>
                        <ListItemButton onClick={(e: any) => handleClick(item.idDroit)}>
                            <Checkbox
                                checked={rightsChecked.indexOf(item.idDroit) !== -1}
                                tabIndex={-1}
                            />
                            <ListItemText
                                primary={`${item.libelle}`}
                                secondary={`${item?.descriptionDroit ? item?.descriptionDroit : ""}`}
                            />
                        </ListItemButton>
                    </ListItem>
                ))
                }
            </List>
        </Box>
    );
}
